import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-assets-allocation-modal',
  templateUrl: './assets-allocation-modal.component.html',
  styleUrls: ['./assets-allocation-modal.component.scss']
})
export class AssetsAllocationModalComponent implements OnInit {
  staffList  = []
  siteList  = []
  jobList = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>,
    public dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit() {
    console.log("this .data", this.data);
    let singleAsset  = this.data.asset
    this.staffList = singleAsset.userAllocation
    this.siteList = singleAsset.siteList
    this.jobList = singleAsset.linkedAsset.filter((x) => x.linkedType === 'labourjob')
  }

singleAssettype(){
  console.log("DATA ", this.data);
  let assetType = this.data.asset.assetTypeId
  this.router.navigate(['/asset/single-type-asset/' + assetType._id], { queryParams: { '_noAsset': this.data.count.totalAssets } })  
  this.dialogRef.close()
}

}
